/* eslint-disable import/no-cycle */
import {
  mixpanelInit, mixpanelReset,
  mixpanleIdentifyUser, trackMPEvent
} from '../../../utils/analytics/implementations/mixpanel';
import { hotJarinitialize, hotJarIdentifyUser, hotJarReset } from '../../../utils/analytics/implementations/hotjar';
import { trackGTMEvent } from '../../../utils/analytics/implementations/google_tag_manager';
import { prepareSessionBeganEventProperties } from './session_began_event';

export const initializeAnalytics = () => {
  prepareSessionBeganEventProperties();
  mixpanelInit();
  hotJarinitialize();
};

export const resetAnalytics = () => {
  mixpanelReset();
  hotJarReset();
};

export const identifyUser = () => (dispatch, getState) => {
  prepareSessionBeganEventProperties();
  dispatch(mixpanleIdentifyUser());
  const { user: { userId }  } = getState().user;
  hotJarIdentifyUser(userId);
};

export const trackEvent = (eventName, eventProps) => {
  trackMPEvent(eventName, eventProps);
  trackGTMEvent(eventName, eventProps);
};
